import { FloatingField } from '../../components/FloatingField';
import { FormCard } from '../../components/FormCard';
import { Input } from '../../components/Input';
import {
  AcceptedCardsRow,
  FormError,
  Row,
  SectionTitle,
  Stack,
  Wrapper,
} from './PaymentMethodForm.styles';
import type { PaymentMethodFormLabels, PaymentMethodFormProps } from './PaymentMethodForm.types';

const DEFAULT_LABELS: Required<PaymentMethodFormLabels> = {
  sectionTitle: 'Add a payment method',
  cardNumberLabel: 'Card number',
  expiryLabel: 'Expiry date (MM/YY)',
  cvvLabel: 'CVV',
  nameOnCardLabel: 'Name on card',
  acceptedCardsAriaLabel: 'Accepted cards',
};

export function PaymentMethodForm({
  nameOnCard,
  onNameOnCardChange,
  cardNumberSlot,
  expirySlot,
  cvvSlot,
  cardNumberFilled = false,
  expiryFilled = false,
  cvvFilled = false,
  acceptedCards,
  showHeader = true,
  errors,
  labels,
}: PaymentMethodFormProps) {
  const merged = { ...DEFAULT_LABELS, ...labels };

  return (
    <Wrapper data-testid="payment-method-form">
      {showHeader && <SectionTitle>{merged.sectionTitle}</SectionTitle>}

      <Stack>
        <FormCard>
          {cardNumberSlot && (
            <FloatingField
              label={merged.cardNumberLabel}
              hasValue={cardNumberFilled}
              error={errors?.cardNumber}
            >
              {cardNumberSlot}
            </FloatingField>
          )}

          {(expirySlot || cvvSlot) && (
            <Row>
              {expirySlot && (
                <FloatingField
                  label={merged.expiryLabel}
                  hasValue={expiryFilled}
                  error={errors?.expiry}
                >
                  {expirySlot}
                </FloatingField>
              )}
              {cvvSlot && (
                <FloatingField label={merged.cvvLabel} hasValue={cvvFilled} error={errors?.cvv}>
                  {cvvSlot}
                </FloatingField>
              )}
            </Row>
          )}

          <FloatingField
            label={merged.nameOnCardLabel}
            hasValue={Boolean(nameOnCard)}
            error={errors?.nameOnCard}
          >
            <Input
              type="text"
              autoComplete="cc-name"
              value={nameOnCard}
              onChange={(e) => onNameOnCardChange(e.target.value)}
              error={Boolean(errors?.nameOnCard)}
              placeholder={`${merged.nameOnCardLabel}*`}
              aria-label={merged.nameOnCardLabel}
            />
          </FloatingField>
        </FormCard>

        {errors?.form && <FormError role="alert">{errors.form}</FormError>}

        {acceptedCards && (
          <AcceptedCardsRow aria-label={merged.acceptedCardsAriaLabel}>
            {acceptedCards}
          </AcceptedCardsRow>
        )}
      </Stack>
    </Wrapper>
  );
}
